// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dialog Content */
mat-dialog-content {
    min-width: 900px;
    padding: 2px 16px !important;
    background-color: #f0f0f0;
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
}

mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 8px 24px !important;
    display: flex !important;
    justify-content: flex-end !important;
}

/* White content box — matches manage-materials */
.content {
    padding: 10px 16px;
    border-radius: 4px;
    overflow: hidden;
    margin: 0 8px;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

/* Section Headers */
.add-material-section h3,
.materials-search-section h3 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 800;
    color: #0b2d71;
}

/* Add Material Form */
.add-material-form {
    border: 1px solid #0066B2;
    border-radius: 4px;
    padding: 12px;
}

.add-material-form .form-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    align-items: end;
    margin-bottom: 12px;
}

.add-material-form .form-field {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.material-name-cell {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    min-width: 0;
}

.material-name-cell .form-field {
    flex: 1;
    min-width: 0;
}

.add-material-form .form-field label {
    margin-bottom: 4px;
    text-align: center;
}

.cispro-container-field .input-with-icons {
    display: flex;
    align-items: center;
    border: 1px solid #E21836;
    border-radius: 2px;
    background-color: #fff;
}

.cispro-container-field .cispro-input {
    border: none;
    flex: 1;
    width: 100px;
}

.cispro-container-field .cispro-input:focus {
    outline: none;
}

/* Icon Buttons */
.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
}

.clear-icon {
    color: #E21836;
}
.search-fields {
    display: grid;
    grid-template-columns: repeat(4, auto);
    gap: 24px;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 auto;
    align-items: center;
}

.search-field {
    display: flex;
    align-items: center;
    gap: 6px;
}

.search-field label {
    white-space: nowrap;
}

.search-field input {
    width: 130px;
}

.search-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
}

/* States */
.loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px;
}

.loading-spinner p {
    margin-top: 16px;
}

.error-message {
    padding: 16px;
    margin-bottom: 16px;
    background-color: #DBDCDD;
    color: #E21836;
    border-left: 4px solid #E21836;
}

/* Materials Table */
.materials-table-container {
    width: 100%;
    max-height: calc(36px * 5 + 37px + 16px);
    overflow-x: auto;
    overflow-y: auto;
    margin-top: 16px;
    border: 1px solid #dbdcdd;
    scrollbar-gutter: stable;
}

.materials-table {
    width: 100%;
    border-collapse: collapse;
    min-width: max-content;
}

.table-header {
    background-color: #0066B2;
    color: #ffffff;
    position: sticky;
    top: 0;
    text-align: left;
    white-space: nowrap;
    z-index: 1;
}

.table-header td {
    padding: 8px;
    font-weight: bold;
    white-space: nowrap;
}

.material-row {
    cursor: pointer;
}

.material-row:hover {
    background-color: #f5f5f5;
}

.material-row td {
    padding: 6px 8px;
    border-bottom: 1px solid #e0e0e0;
    height: 36px;
}

.center {
    text-align: center;
}

.field-value {
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/materials-qaqc/materials-qaqc.component.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE,oBAAoB;AACpB;;IAEI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,8BAA8B;AAClC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["/* Dialog Content */\nmat-dialog-content {\n    min-width: 900px;\n    padding: 2px 16px !important;\n    background-color: #f0f0f0;\n    max-height: 80vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n}\n\n/* White content box — matches manage-materials */\n.content {\n    padding: 10px 16px;\n    border-radius: 4px;\n    overflow: hidden;\n    margin: 0 8px;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n/* Section Headers */\n.add-material-section h3,\n.materials-search-section h3 {\n    margin: 0 0 8px 0;\n    font-size: 16px;\n    font-weight: 800;\n    color: #0b2d71;\n}\n\n/* Add Material Form */\n.add-material-form {\n    border: 1px solid #0066B2;\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.add-material-form .form-row {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n    align-items: end;\n    margin-bottom: 12px;\n}\n\n.add-material-form .form-field {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.material-name-cell {\n    display: flex;\n    align-items: flex-end;\n    gap: 4px;\n    min-width: 0;\n}\n\n.material-name-cell .form-field {\n    flex: 1;\n    min-width: 0;\n}\n\n.add-material-form .form-field label {\n    margin-bottom: 4px;\n    text-align: center;\n}\n\n.cispro-container-field .input-with-icons {\n    display: flex;\n    align-items: center;\n    border: 1px solid #E21836;\n    border-radius: 2px;\n    background-color: #fff;\n}\n\n.cispro-container-field .cispro-input {\n    border: none;\n    flex: 1;\n    width: 100px;\n}\n\n.cispro-container-field .cispro-input:focus {\n    outline: none;\n}\n\n/* Icon Buttons */\n.icon-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 2px;\n}\n\n.clear-icon {\n    color: #E21836;\n}\n.search-fields {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    gap: 24px;\n    width: fit-content;\n    margin: 0 auto;\n    align-items: center;\n}\n\n.search-field {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.search-field label {\n    white-space: nowrap;\n}\n\n.search-field input {\n    width: 130px;\n}\n\n.search-actions {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n    margin-top: 3px;\n}\n\n/* States */\n.loading-spinner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 48px;\n}\n\n.loading-spinner p {\n    margin-top: 16px;\n}\n\n.error-message {\n    padding: 16px;\n    margin-bottom: 16px;\n    background-color: #DBDCDD;\n    color: #E21836;\n    border-left: 4px solid #E21836;\n}\n\n/* Materials Table */\n.materials-table-container {\n    width: 100%;\n    max-height: calc(36px * 5 + 37px + 16px);\n    overflow-x: auto;\n    overflow-y: auto;\n    margin-top: 16px;\n    border: 1px solid #dbdcdd;\n    scrollbar-gutter: stable;\n}\n\n.materials-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: max-content;\n}\n\n.table-header {\n    background-color: #0066B2;\n    color: #ffffff;\n    position: sticky;\n    top: 0;\n    text-align: left;\n    white-space: nowrap;\n    z-index: 1;\n}\n\n.table-header td {\n    padding: 8px;\n    font-weight: bold;\n    white-space: nowrap;\n}\n\n.material-row {\n    cursor: pointer;\n}\n\n.material-row:hover {\n    background-color: #f5f5f5;\n}\n\n.material-row td {\n    padding: 6px 8px;\n    border-bottom: 1px solid #e0e0e0;\n    height: 36px;\n}\n\n.center {\n    text-align: center;\n}\n\n.field-value {\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
